import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


 export function setInfoSuccess(paginaInfo) {
  return {type: types.SET_STRINGS_SUCCESS, datos:paginaInfo};
}


export function getInfo(pagina, token) {
    
	return dispatch => {
         
		      dispatch(beginAjaxCall());
		      return Api().PaginaApi.getInfo(pagina, token).then(paginaInfo => {                  
                  dispatch(setInfoSuccess(paginaInfo));
                   
                  return paginaInfo;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}